module.exports = __webpack_public_path__ + "static/media/grants.710286d3.svg";